import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";
import { ColorPicker } from "antd";
import type { ColorPickerProps, GetProp } from "antd";
import {
  setDataSidebarAll,
  setDataTopbarAll,
  setDataTopBarColorAll,
  setDataColorAll,
  setDataLayout,
  setDataWidth,
  setDataCard,
  setTopBarColor,
  setTopBarColor2,
  setDataTheme,
  setDataSidebar,
  setDataSidebarBg,
  setDataTopbarBg,
  setDataColor,
  setLoader,
  resetAllMode,
  setRtl,
} from "../../data/redux/themeSettingSlice";

type Color = Extract<
  GetProp<ColorPickerProps, "value">,
  string | { cleared: any }
>;
const ThemeSettings = () => {
  
  return (
    <>
    </>
  );
};

export default ThemeSettings;
